// Article JSON-LD helper for Knowledge Academy guides.
// Kept separate from seoSchemas.js to avoid touching an established file.

const SITE = 'https://wpaauae.com';

export const articleSchema = ({ headline, description, path, author = 'White Paper Accounts Auditing', datePublished, dateModified }) => {
  const now = new Date().toISOString();
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    description,
    author: {
      '@type': 'Organization',
      name: author,
      url: SITE
    },
    publisher: {
      '@type': 'Organization',
      name: 'White Paper Accounts Auditing',
      url: SITE,
      logo: {
        '@type': 'ImageObject',
        url: `${SITE}/og-image.png`
      }
    },
    datePublished: datePublished || now,
    dateModified: dateModified || now,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${SITE}${path}`
    }
  };
};
